<div class="filters__header">
    <h5 class="filters__header__title">{{ "AUDIT.HISTORIC" | translate }}</h5>
    <div class="filters__header__actions">
        <button class="button-icon" id="botonCerrar2" (click)="close.emit(true)">
            <i class="icon-close"></i>
        </button>
    </div>
</div>
<div class="filters__body">
    <div class="info-group">
        <b>{{ "AUDIT.EVENT" | translate }}</b>
        <span *ngIf="customTitle()">{{ customTitle() }}</span>
        <span *ngIf="!customTitle()">{{ "AUDIT.EVIDENCES.LONG." + evidence.type | translate }}</span>
    </div>
    <div class="divider"></div>
    <div class="info-group">
        <b>{{ "AUDIT.EVENT_ID" | translate }}</b>
        <span>{{ evidence.event_id }}</span>
    </div>
    <ng-container *ngIf="receiver">
        <div class="divider"></div>
        <div class="info-group">
            <b>{{ "AUDIT.USER" | translate }}</b>
            <span>{{ receiver.name }} {{ receiver.surname }} ({{ receiver.email }})</span>
        </div>
    </ng-container>

    <div class="divider"></div>
    <div class="info-group">
        <b>{{ "AUDIT.DATETIME" | translate }}</b>
        <span>{{ timeService.timestampToFormat(evidence.timestamp) }} (UTC)</span>
    </div>
    <div class="divider"></div>
    <div class="info-group">
        <b>{{ "AUDIT.SYSTEM" | translate }}</b>
        <span>{{ evidence.useragent }}</span>
    </div>
    <div class="divider"></div>
    <div class="info-group">
        <b>{{ "AUDIT.IP" | translate }}</b>
        <span>{{ evidence.ip }}</span>
    </div>
    <div class="divider"></div>
    <div class="info-group">
        <b>{{ "AUDIT.OPERATION_ID_LONG" | translate }}</b>
        <span>{{ document.operation_id | uppercase }}</span>
    </div>

    <ng-container *ngIf="hasCustomEntries()">
        <ng-container *ngFor="let custom_entry of evidence.custom_entries">
            <div class="divider"></div>
            <div class="info-group">
                <b>{{ custom_entry.title }}</b>
                <span>{{ custom_entry.text }}</span>
            </div>
        </ng-container>
    </ng-container>


</div>